export enum UserIdentityDocumentType {
    Passport = 'Passport',
    IdentityCard = 'IdentityCard'
}
